import { useEffect, useState } from "react";
import { getthirdpartyData } from "V2.0/services/thirdpartyService";

export default function useThridPartyCommunicationChannel({ workspaceId }) {
  const [communicationChannel, setCommunicationChannel] = useState({
    phoneNumbers: [],
    emailAddresses: [],
    emailProvider: "",
  });

  const updatePhoneNumbers = function (phoneNumbers) {
    setCommunicationChannel(function (prevState) {
      return {
        ...prevState,
        phoneNumbers,
      };
    });
  };

  const updateEmailAddresses = function (emailAddresses, emailProvider) {
    setCommunicationChannel(function (prevState) {
      return {
        ...prevState,
        emailAddresses,
        emailProvider,
      };
    });
  };

  const fetchCommunicationChannels = async () => {
    try {
      const response = await getthirdpartyData(workspaceId);
      if (response.status === 200) {
        const { telephonySettings, emailSettings } = response.data;
        if (telephonySettings.telephonyProvider === "twilio") {
          updatePhoneNumbers(telephonySettings.twilioSettings.phoneNumbers);
        }

        if (telephonySettings.telephonyProvider === "plivo") {
          updatePhoneNumbers(telephonySettings.plivoSettings.phoneNumbers);
        }

        if (telephonySettings.telephonyProvider === "mcube") {
          updatePhoneNumbers(telephonySettings.mcubeSettings.phoneNumbers);
        }

        if (telephonySettings.telephonyProvider === "cloudonix") {
          updatePhoneNumbers(telephonySettings.cloudonixSettings.phoneNumbers);
        }

        if (telephonySettings.telephonyProvider === "livekit") {
          updatePhoneNumbers(telephonySettings.livekitSettings.phoneNumbers);
        }

        if (telephonySettings.telephonyProvider === "tata") {
          const phoneNumbers = Object.keys(
            telephonySettings.tataSmartFloSettings.phoneNumbersAndAuth
          );
          updatePhoneNumbers(phoneNumbers);
        }

        if (emailSettings.emailProvider === "Gmail") {
          updateEmailAddresses([emailSettings.gmailSettings.emailId], "Gmail");
        }

        if (emailSettings.emailProvider === "SendGrid") {
          const emailAddresses = emailSettings.sendGridSettings.sender.map(
            function (sender) {
              return sender.fromEmail;
            }
          );

          updateEmailAddresses(emailAddresses, "SendGrid");
        }
      }
    } catch (e) {
      console.error("Error getting third party data");
    }
  };

  useEffect(
    function () {
      if (workspaceId) {
        fetchCommunicationChannels();
      }
    },
    [workspaceId]
  );

  return {
    communicationChannel,
    fetchCommunicationChannels,
  };
}
